import { render, staticRenderFns } from "./VehiculesCard.vue?vue&type=template&id=da0b7b94&"
import script from "./VehiculesCard.vue?vue&type=script&lang=js&"
export * from "./VehiculesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports